module.exports = __webpack_public_path__ + "static/media/step-big-blank-mobile.894f9899.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/step-big-blank-mobile.svg
// module id = 858
// module chunks = 21